const frequencyOptions: { [key: string]: string } = {
  monthly: 'Monthly',
  weekly: 'Weekly',
  'semi-monthly': 'Semi-Monthly',
  yearly: 'Annually',
};

export default frequencyOptions;
